import { useCallback } from "react"
import { useAxiosInstances } from "../axios-instance"
import { IIPPermitido } from "../../application/models"

export const useIPPermitidoApi = () => {
    const { axiosAuthInstance } = useAxiosInstances()

    const insertIPPermitidoApi = useCallback(async (data: {
        IdClienteAInserir: number
        IP: string
    }): Promise<void> => {
        try {
            await axiosAuthInstance.post('/ip-permitido/', {
                IdClienteAInserir: data.IdClienteAInserir,
                IP: data.IP
            })

            return
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const updateIPPermitidoApi = useCallback(async (data: {
        IdIPPermitido: number
        Ativo: boolean
        IP?: string
    }): Promise<void> => {
        try {
            await axiosAuthInstance.put(`/ip-permitido/${data.IdIPPermitido}`, {
                Ativo: data.Ativo,
                IP: data.IP
            })

            return
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const getIPPermitidoListByIdClienteApi = useCallback(async (data: {
        IdClienteBusca: number
        Limit: number
        Page: number
    }): Promise<{
        ipList: IIPPermitido[]
        total: number
    }> => {
        try {
            const result = await axiosAuthInstance.get(`/ip-permitido/${data.IdClienteBusca}`, {
                params: {
                    Limit: data.Limit,
                    Page: data.Page
                }
            })
            
            const ipList = result.data.ipList || [];
            const total = result.data.total || 0;

            return {
                ipList,
                total
            }
        } catch (error) {
            throw error;
        }
    }, [axiosAuthInstance])

    return {
        insertIPPermitidoApi,
        updateIPPermitidoApi,
        getIPPermitidoListByIdClienteApi
    }
}